import React, { useState, useEffect }  from "react";
import { format } from "date-fns";
import { notifications } from "../constant/Notify";
import { examinationList } from './constant/BookingConstant'
import axiosService from "../../utils/axios.service";
import { Spin } from "antd"

import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import "./scss/examination.scss";

const ExaminationForm = (props) => {
  const initialFormData = {
    examination_goal: {
      value: 0,
      note: ""
    },

    service_condition: [],
    conclude_condition: 0,

    skin_assessment: [],
    skin_assessment_note: "",

    hair_assessment: [],
    hair_assessment_note: "",

    treatment_assessment: [],
    treatment_assessment_note: "",

    treatment_instruction: [],
    treatment_instruction_adjustment: "",
    treatment_instruction_note: "",

    confirm_examination: {
      value: 0,
      note: ""
    }
  };

  const [formData, setFormData] = useState(null);
  const [statusSubmit, setStatusSubmit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [openSections, setOpenSections] = useState({
    examination_goal: true,
    service_condition: false,
    skin_assessment: false,
    hair_assessment: false,
    treatment_assessment: false,
    treatment_instruction: false,
    confirm_examination: false,
    images: false
  });
  const [consultant, setConsultant] = useState(null);
  const [date, setDate] = useState(new Date());
  const [openLightbox, setOpenLightbox] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files || []);

    if (files.length > 10) {
      notifications({type: "error", mess: "Chỉ được chọn tối đa 10 hình ảnh"});
      return false;
    }

    if (!files.length) return;
    const validFiles = files.filter(file => {
      if (!file.type.startsWith("image/")) {
        notifications({type: "warning", mess: `${file.name} không phải là hình ảnh`});
        return false;
      }

      if (file.size > 10 * 1024 * 1024) {
        notifications({type: "warning", mess: `${file.name} vượt quá 10MB`});
        return false;
      }

      return true;
    });

    setImages(prev => [...prev, ...validFiles]);

    const previews = validFiles.map(file => ({file, url: URL.createObjectURL(file)}));

    setPreviewImages(prev => [...prev, ...previews]);

    e.target.value = "";
  };

  const removeImage = (index) => {
    setPreviewImages(prev => {
      const newList = [...prev];
      URL.revokeObjectURL(newList[index].url);
      newList.splice(index, 1);
      return newList;
    });

    setImages(prev => {
      const newList = [...prev];
      newList.splice(index, 1);
      return newList;
    });
  };

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const changeSingleValue = (field, key, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: {
        ...(prev[field] || {}),
        [key]: value
      }
    }));
  };

  const changeAssessment = (section, key, field, value) => {
    setFormData(prev => {
      const list = prev[section] || [];

      const index = list.findIndex(item => item.key === key);

      if (index !== -1) {
        const newList = [...list];

        newList[index] = {
          ...newList[index],
          [field]: value
        };

        return {
          ...prev,
          [section]: newList
        };
      }

      return {
        ...prev,
        [section]: [
          ...list,
          {
            key,
            value: field === "value" ? value : null,
            note: field === "note" ? value : ""
          }
        ]
      };
    });
  };

  const getAssessment = (section, key) => {
    return (
      formData?.[section]?.find(item => item.key === key) || {
        key,
        value: null,
        note: ""
      }
    );
  };

  // const handleSubmit = async () => {
  //   if (!statusSubmit) return true
  //   setLoading(true)
  //   let payload = {
  //     booking_id: props.booking.id,
  //     customer_id: props.customer.id,
  //     store_id: props.store.id,
  //     data_examination: formData
  //   }
  //   let response = await axiosService("api/examination/save", "POST", payload)

  //   if (response.data.code == 200 && response.data.data) {            
  //     setStatusSubmit(false)
  //     setLoading(false)
  //     notifications({ type: 'success', mess: 'Lưu thành công' });
  //   } else {
  //     setLoading(false)
  //     notifications({ type: 'error', mess: 'Lưu thất bại' });
  //   }
  // };

  const handleSubmit = async () => {
    if (!statusSubmit) return;
    setLoading(true);
    try {
      const payload = new FormData();

      payload.append("booking_id", props.booking.id);
      payload.append("customer_id", props.customer.id);
      payload.append("store_id", props.store.id);

      payload.append("data_examination", JSON.stringify(formData));

      images.forEach(file => {payload.append("images", file)});

      const response = await axiosService("api/examination/save", "POST", payload);

      if (response.data.code === 200 && response.data.data) {
        setStatusSubmit(false);
        notifications({type: "success", mess: "Lưu thành công"});
      } else {
        notifications({type: "error", mess: "Lưu thất bại"});
      }

    } catch (error) {
      console.error(error);
      notifications({type: "error",mess: "Có lỗi xảy ra khi lưu phiếu thăm khám"});
    } finally {
      setLoading(false);
    }
  };

  const convertExaminationData = (data) => {
    const answers = data.answers || [];
    const getAnswersBySection = (section) => {
      return answers.filter(item => item.section === section).map(item => ({
        key: Number(item.question_key),
        value: item.answer_value !== null ? Number(item.answer_value) : null,
        note: item.note || ""
      }));
    };

    return {
      examination_goal: {
        value: data.examination_goal ? Number(data.examination_goal) : 0,
        note: data.examination_goal_note || ""
      },
      service_condition: getAnswersBySection("service_condition"),
      conclude_condition: data.conclude_condition ? Number(data.conclude_condition) : 0,
      skin_assessment: getAnswersBySection("skin_assessment"),
      skin_assessment_note: data.skin_assessment_note || "",
      hair_assessment: getAnswersBySection("hair_assessment"),
      hair_assessment_note: data.hair_assessment_note || "",
      treatment_assessment: getAnswersBySection("treatment_assessment"),
      treatment_assessment_note: data.treatment_assessment_note || "",
      treatment_instruction: getAnswersBySection("treatment_instruction"),
      treatment_instruction_adjustment: data.treatment_instruction_adjustment || "",
      treatment_instruction_note: data.treatment_instruction_note || "",
      confirm_examination: {
        value: data.confirm_examination ? Number(data.confirm_examination) : 0,
        note: data.confirm_examination_note || ""
      }
    };
  };

  const validateForm = () => {
    if (!formData) return false
    if (!formData.examination_goal?.value) return false;
    if (Number(formData.examination_goal.value) === 7 && !formData.examination_goal.note?.trim()) {
      return false;
    }

    let statusServiceCondition = examinationList.service_condition.every(item => {
      const answer = getAssessment("service_condition", item.key);

      return (answer.value !== null && answer.value !== undefined);
    })
    if (!statusServiceCondition) return false;
    
    if (!formData.conclude_condition) return false;

    let statusSkinAssessment = examinationList.skin_assessment.every(item => {
      const answer = getAssessment("skin_assessment", item.key);

      return (answer.value !== null && answer.value !== undefined);
    })
    if (!statusSkinAssessment) return false;
    
    let statusHairAssessment = examinationList.hair_assessment.every(item => {
      const answer = getAssessment("hair_assessment", item.key);

      return (answer.value !== null && answer.value !== undefined);
    })
    if (!statusHairAssessment) return false;
    
    let statusTreatmentAssessment = examinationList.treatment_assessment.every(item => {
      const answer = getAssessment("treatment_assessment", item.key);

      return (answer.value !== null && answer.value !== undefined);
    })
    if (!statusTreatmentAssessment) return false;
    

    let statusTreatmentInstruction = examinationList.treatment_instruction.every(item => {
      const answer = getAssessment("treatment_instruction", item.key);

      return (answer.value !== null && answer.value !== undefined);
    })
    if (!statusTreatmentInstruction) return false;
    

    if (!formData.confirm_examination?.value) return false;
    if (Number(formData?.confirm_examination?.value) === 2 && !formData?.confirm_examination?.note?.trim()) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    const fetchData = async () => {
      let response = await axiosService(`api/examination/get-by-id/${props?.booking?.id}`, "GET");
      if (response.data.code == 200 && response.data.data) {            
        setFormData(convertExaminationData(response.data.data))
        setExistingImages(response.data.data.images || []);
        setConsultant(response.data.data.user)
        setDate(new Date(response.data.data.created_at))
        setStatusSubmit(false)
      } else {
        setFormData(initialFormData)
      }
    }
    fetchData()
  }, [props?.booking?.id])

  // useEffect(() => {
  //   const isValid = validateForm();
  //   setStatusSubmit(isValid);
  // }, [formData]);

  return (
    <div className="popup-cent popup-examination">
      <div className="content-popup fadeInDown">
        <div className="head-popup">
          <div className="title">Phiếu thăm khám khách hàng</div>
          <div className="close" onClick={props.onClose}>×</div>
        </div>
        <Spin spinning={loading} size="large" tip="Đang tải...">
          <div className="body-popup">
            <div className="list-examination">
              <div className="item-examination">
                <div className="head-item">
                  <div className="title">I. THÔNG TIN THĂM KHÁM</div>
                </div>
                <div className="content-item">
                  <div className="item-question">
                    <div className="answer">
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Họ và tên:</div>
                          <div className="value bold">{props.customer.full_name}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Số điện thoại:</div>
                          <div className="value bold">{props.customer.mobile}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Ngày thăm khám:</div>
                          <div className="value">{format(date, "yyyy-MM-dd")}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Cơ sở:</div>
                          <div className="value">{props.store.name_store}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Tư vấn viên:</div>
                          <div className="value">{consultant ? consultant.name : props.user.name}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title w-100">Nhóm khách hàng:</div>
                          <div className="value w-100 text-left">
                            {(props.booking?.bookingType || []).map((x, y) => (
                              <p key={y}>
                                {`- N${x.type}: ${
                                  x.type === 1 ? "Khách lần đầu sử dụng dịch vụ" : 
                                  x.type === 3 ? `Khách feedback ngày ${format(new Date(x.feed_back), "yyyy-MM-dd HH:mm:ss")}` : 
                                  x.type === 4 ? "Khách có nhu cầu tư vấn" : 
                                  x.package ? `${x.package.package_code} - ${x.package.product_name}` : ""
                                }`}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('examination_goal')}>
                  <div className="title">II. MỤC TIÊU BUỔI THĂM KHÁM</div>
                  <div className="desc">Chỉ chọn 01 mục tiêu chính</div>
                </div>
                <div className={`examination-content ${openSections.examination_goal ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      <div className="item-question">
                        <div className="answer">
                          {examinationList.examination_goal.map((x,y) => {
                            return (
                              <div className="answer-item" key={y}>
                                <div className={`group-form group-radio`}>
                                  <label htmlFor={`target_${x.value}`} className={`d-flex align-items-center`}>
                                    <input disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))} type="radio" name="target" id={`target_${x.value}`} value={x.value}
                                      checked={formData?.examination_goal?.value === Number(x.value)}
                                      onChange={(e) => changeSingleValue("examination_goal", "value", Number(e.target.value))}
                                    />
                                    <i className="fa-solid fa-check"></i>
                                    <div className="text">{x.title}</div>
                                  </label>
                                </div>
                              </div>
                            )
                          })}
                          {formData?.examination_goal?.value === 7 && (
                            <textarea placeholder="Vui lòng điền lý do" value={formData?.examination_goal?.note || ""}
                              disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                              onChange={(e) => changeSingleValue("examination_goal", "note", e.target.value)}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('service_condition')}>
                  <div className="title">III. ĐÁNH GIÁ ĐIỀU KIỆN LÀM DỊCH VỤ</div>
                  <div className="desc">(Mục tiêu: Khách có đủ điều kiện thực hiện dịch vụ tại thời điểm thăm khám hay không)</div>
                </div>
                <div className={`examination-content ${openSections.service_condition ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      {examinationList.service_condition.map((x,y) => {
                        const current = getAssessment( "service_condition", x.key);
                        return (
                          <div key={y} className="item-question">
                            <div className="question">{`${y+1}. ${x.criteria}`}</div>
                            <div className="answer row">
                              {x.answer.map((a,b) => {
                                return (
                                  <div key={b} className="answer-item w-50">
                                    <div className={`group-form group-radio`}>
                                      <label htmlFor={`condition_${x.key}_${a.value}`} className={`d-flex align-items-center`}>
                                        <input disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                          type="radio" name={`condition_${x.key}`} id={`condition_${x.key}_${a.value}`} value={a.value}
                                          checked={Number(current.value) === Number(a.value)}
                                          onChange={(e) => changeAssessment("service_condition", x.key, "value", Number(e.target.value))}
                                        />
                                        <i className="fa-solid fa-check"></i>
                                        <div className="text">{a.title}</div>
                                      </label>
                                    </div>
                                  </div>
                                )
                              })}
                              <textarea placeholder="Ghi chú" value={current.note || ""}
                                disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                onChange={(e) => changeAssessment("service_condition", x.key, "note", e.target.value )} 
                              />
                            </div>
                          </div>
                        )
                      })}
                      <div className="item-question">
                        <div className="question">{`${examinationList.service_condition.length + 1}. Kết luận`}</div>
                        <div className="answer row">
                          {examinationList.conclude_condition.map((x,y) => {
                            return (
                              <div className="answer-item w-100" key={y}>
                                <div className={`group-form group-radio`}>
                                  <label htmlFor={`conclude_condition_${x.value}`} className={`d-flex align-items-center`}>
                                    <input type="radio" name="conclude_condition" id={`conclude_condition_${x.value}`} value={x.value}
                                      disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                      checked={formData?.conclude_condition === Number(x.value)}
                                      onChange={(e) => setFormData(prev => ({...prev, conclude_condition: Number(e.target.value)}))}
                                    />
                                    <i className="fa-solid fa-check"></i>
                                    <div className="text">{x.title}</div>
                                  </label>
                                </div>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('skin_assessment')}>
                  <div className="title">IV. ĐÁNH GIÁ TÌNH TRẠNG DA</div>
                  <div className="desc">Mục tiêu: Đánh giá tình trạng da để quyết định thông số cho từng vùng</div>
                </div>
                <div className={`examination-content ${openSections.skin_assessment ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      {examinationList.skin_assessment.map((x,y) => {
                        const current = getAssessment("skin_assessment", x.key);
                        return (
                          <div key={y} className="item-question">
                            <div className="question">{`${y+1}. ${x.criteria}`}</div>
                            <div className="answer row">
                              {x.answer.map((a,b) => {
                                return (
                                  <div key={b} className="answer-item w-50">
                                    <div className={`group-form group-radio`}>
                                      <label htmlFor={`skin_assessment_${x.key}_${a.value}`} className={`d-flex align-items-center`}>
                                        <input type="radio" name={`skin_assessment_${x.key}`} id={`skin_assessment_${x.key}_${a.value}`} value={a.value}
                                          disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                          checked={Number(current.value) === Number(a.value)}
                                          onChange={(e) => changeAssessment("skin_assessment", x.key, "value", Number(e.target.value))}
                                        />
                                        <i className="fa-solid fa-check"></i>
                                        <div className="text">{a.title}</div>
                                      </label>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                      <div className="item-question">
                        <div className="question">{`${examinationList.skin_assessment.length + 1}. Nhận định của tư vấn viên`}</div>
                        <div className="answer">
                          <div className="answer-item">
                            <div className={`group-form group-textarea`}>
                              <textarea placeholder="Vui lòng điền nhận định."
                                disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                value={formData?.skin_assessment_note || ""}
                                onChange={(e) => setFormData(prev => ({...prev, skin_assessment_note: e.target.value}))} 
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('hair_assessment')}>
                  <div className="title">V. ĐÁNH GIÁ TÌNH TRẠNG LÔNG</div>
                </div>
                <div className={`examination-content ${openSections.hair_assessment ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      {examinationList.hair_assessment.map((x,y) => {
                        const current = getAssessment("hair_assessment", x.key);
                        return (
                          <div key={y} className="item-question">
                            <div className="question">{`${y+1}. ${x.criteria}`}</div>
                            <div className="answer row">
                              {x.answer.map((a,b) => {
                                return (
                                  <div key={b} className="answer-item w-50">
                                    <div className={`group-form group-radio`}>
                                      <label htmlFor={`hair_assessment_${x.key}_${a.value}`} className={`d-flex align-items-center`}>
                                        <input type="radio" name={`hair_assessment_${x.key}`} id={`hair_assessment_${x.key}_${a.value}`} value={a.value} 
                                          disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                          checked={Number(current.value) === Number(a.value)}
                                          onChange={(e) => changeAssessment("hair_assessment", x.key, "value", Number(e.target.value))}
                                        />
                                        <i className="fa-solid fa-check"></i>
                                        <div className="text">{a.title}</div>
                                      </label>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                      <div className="item-question">
                        <div className="question">{`${examinationList.hair_assessment.length + 1}. Vùng lông phát triển mạnh`}</div>
                        <div className="answer">
                          <div className="answer-item">
                            <div className={`group-form group-textarea`}>
                              <textarea placeholder="Vui lòng điền nhận định." value={formData?.hair_assessment_note || ""}
                                disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                onChange={(e) => setFormData(prev => ({...prev, hair_assessment_note: e.target.value}))} 
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('treatment_assessment')}>
                  <div className="title">VI. ĐÁNH GIÁ HIỆU QUẢ DỊCH VỤ</div>
                  <div className="desc">Không áp dụng với khách hàng thuộc nhóm N1</div>
                </div>
                <div className={`examination-content ${openSections.treatment_assessment ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      {examinationList.treatment_assessment.map((x,y) => {
                        const current = getAssessment("treatment_assessment", x.key);
                        return (
                          <div key={y} className="item-question">
                            <div className="question">{`${y+1}. ${x.criteria}`}</div>
                            <div className="answer row">
                              {x.answer.map((a,b) => {
                                return (
                                  <div key={b} className="answer-item w-50">
                                    <div className={`group-form group-radio`}>
                                      <label htmlFor={`treatment_assessment_${x.key}_${a.value}`} className={`d-flex align-items-center`}>
                                        <input type="radio" name={`treatment_assessment_${x.key}`} id={`treatment_assessment_${x.key}_${a.value}`} value={a.value}
                                          disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                          checked={Number(current.value) === Number(a.value)}
                                          onChange={(e) => changeAssessment("treatment_assessment", x.key, "value", Number(e.target.value))}
                                        />
                                        <i className="fa-solid fa-check"></i>
                                        <div className="text">{a.title}</div>
                                      </label>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                      <div className="item-question">
                        <div className="question">{`${examinationList.treatment_assessment.length + 1}. Đánh giá hiệu quả`}</div>
                        <div className="answer">
                          <div className="answer-item">
                            <div className={`group-form group-textarea`}>
                              <textarea placeholder="Vui lòng điền nhận định." 
                                disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                value={formData?.treatment_assessment_note || ""}
                                onChange={(e) => setFormData(prev => ({...prev, treatment_assessment_note: e.target.value}))}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('treatment_instruction')}>
                  <div className="title">VII. CHỈ ĐỊNH CHO CHUYÊN VIÊN DỊCH VỤ</div>
                </div>
                <div className={`examination-content ${openSections.treatment_instruction ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      {examinationList.treatment_instruction.map((x,y) => {
                        const current = getAssessment("treatment_instruction", x.key);
                        return (
                          <div key={y} className="item-question">
                            <div className="question">{`${y+1}. ${x.criteria}`}</div>
                            <div className="answer row">
                              {x.answer.map((a,b) => {
                                return (
                                  <div key={b} className="answer-item w-50">
                                    <div className={`group-form group-radio`}>
                                      <label htmlFor={`treatment_instruction_${x.key}_${a.value}`} className={`d-flex align-items-center`}>
                                        <input type="radio" name={`treatment_instruction_${x.key}`} id={`treatment_instruction_${x.key}_${a.value}`} value={a.value} 
                                          disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                          checked={Number(current.value) === Number(a.value)}
                                          onChange={(e) => changeAssessment("treatment_instruction", x.key, "value", Number(e.target.value))}
                                        />
                                        <i className="fa-solid fa-check"></i>
                                        <div className="text">{a.title}</div>
                                      </label>
                                    </div>
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        )
                      })}
                      <div className="item-question">
                        <div className="question">{`${examinationList.treatment_instruction.length + 1}. Điều chỉnh kỹ thuật`}</div>
                        <div className="answer">
                          <div className="answer-item">
                            <div className={`group-form group-textarea`}>
                              <textarea placeholder="Vui lòng điền nhận định."
                                disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                value={formData?.treatment_instruction_adjustment || ""}
                                onChange={(e) => setFormData(prev => ({...prev, treatment_instruction_adjustment: e.target.value}))}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="item-question">
                        <div className="question">{`${examinationList.treatment_instruction.length + 2}. Lưu ý khi thực hiện`}</div>
                        <div className="answer">
                          <div className="answer-item">
                            <div className={`group-form group-textarea`}>
                              <textarea placeholder="Vui lòng điền nhận định." 
                                disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                value={formData?.treatment_instruction_note || ""}
                                onChange={(e) => setFormData(prev => ({...prev, treatment_instruction_note: e.target.value}))}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('confirm_examination')}>
                  <div className="title">VIII. XÁC NHẬN THĂM KHÁM</div>
                </div>
                <div className={`examination-content ${openSections.confirm_examination ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      <div className="item-question">
                        <div className="answer">
                          {examinationList.confirm_examination.map((x,y) => {
                            return (
                              <div className="answer-item" key={y}>
                                <div className={`group-form group-radio`}>
                                  <label htmlFor={`confirm_examination_${x.value}`} className={`d-flex align-items-center`}>
                                    <input type="radio" name="confirm_examination" id={`confirm_examination_${x.value}`} value={x.value} 
                                      disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                                      checked={formData?.confirm_examination?.value === Number(x.value)}
                                      onChange={(e) => changeSingleValue("confirm_examination", "value", Number(e.target.value))}
                                    />
                                    <i className="fa-solid fa-check"></i>
                                    <div className="text">{x.title}</div>
                                  </label>
                                </div>
                              </div>
                            )
                          })}
                          {formData?.confirm_examination?.value === 2 ? 
                            <textarea placeholder="Vui lòng điền lý do"
                              value={formData?.confirm_examination?.note || ""}
                              disabled={!statusSubmit || ![1,2,3,4].includes(Number(props.booking.book_status))}
                              onChange={(e) => changeSingleValue("confirm_examination", "note", e.target.value)}
                            />
                          :null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection("images")}>
                  <div className="title">IX. HÌNH ẢNH</div>
                </div>
                <div className={`examination-content ${openSections.images ? "show" : ""}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      <div className="item-question">
                        <div className="answer">
                          {statusSubmit && [1, 2, 3, 4].includes(Number(props.booking.book_status)) && (
                            <div className="image-upload">
                              <label htmlFor="examination-images" className="image-upload-button">
                                <i className="fas fa-camera"></i>
                                <span>Chọn hình ảnh</span>
                              </label>
                              <input id="examination-images" type="file" accept="image/*" multiple hidden onChange={handleImageChange}/>
                            </div>
                          )}
                          
                            <div className="image-preview-list">
                              {previewImages.length > 0 ? 
                                previewImages.map((item, index) => (
                                  <div className="image-preview-item" key={`${item.url}-${index}`}>
                                    <img src={item.url} alt={`Hình ảnh ${index + 1}`} />
                                    {statusSubmit && (<button type="button" className="remove-image" onClick={() => removeImage(index)}>×</button>)}
                                  </div>
                                ))
                              :null}
                              {existingImages.map((image, index)=> (
                                <div className="image-preview-item" key={index}
                                onClick={() => {setLightboxIndex(index); setOpenLightbox(true)}}>
                                  <img src={image.file_url} alt={image.file_name} />
                                </div>
                              ))}
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-popup">
            <div className="button-container">
              <div className="button-cent style3" onClick={props.onClose}>
                <span><i className="fas fa-times"></i></span>Đóng
              </div>
              {statusSubmit && [1,2,3,4].includes(Number(props.booking.book_status)) ? 
                <div className="button-cent" onClick={handleSubmit}>
                  <span><i className="fas fa-save"></i></span>Gửi
                </div>
              :null}
            </div>
          </div>
        </Spin>
      </div>
      <Lightbox open={openLightbox} close={() => setOpenLightbox(false)} index={lightboxIndex}
        slides={existingImages.map((image) => ({ src: image.file_url, alt: image.file_name})) || []}
        plugins={[Thumbnails, Zoom]}
        zoom={{
          maxZoomPixelRatio: 3,
          scrollToZoom: true,
        }}
      />
      <div className="overlay" onClick={() => props.overflowClose ? props.onClose() : null}></div>
    </div>
  );
}

export default ExaminationForm;
